import {
  FiClock,
  FiDollarSign,
  FiHelpCircle,
  FiTrendingUp,
} from "react-icons/fi";
import React from "react";

export const painPoints = [
  {
    icon: <FiClock />,
    title: "You’re starting a business, but time is limited",
    text: "You know you need a professional online presence, but building it yourself takes focus away from running the business.",
  },
  {
    icon: <FiHelpCircle />,
    title: "You don’t know where to start",
    text: "Website, online shop, booking system, branding, marketing, content — it can be hard to know what should come first.",
  },
  {
    icon: <FiDollarSign />,
    title: "Website builders look cheap, until they don’t",
    text: "Monthly plans, plugins, templates, platform limits, and extra tools can quickly become more expensive than expected.",
  },
  {
    icon: <FiTrendingUp />,
    title: "You don’t know how to market yourself online",
    text: "Having a website is only one part. You also need clear messaging, visibility, and a way to turn visitors into customers.",
  },
];
